import { checkBypassMode } from 'marketing/lib/lib'
import { createSelector } from 'reselect'

export const isPaidSessionSelector = createSelector(
  (state: App.State) => state.utm,
  (utm) => checkBypassMode(utm.bp),
)

/**
 * Whether the offer region filter bypass (MLOS) applies to a given offer: the bypass is on for
 * the visit, and svc-promo does not exclude this offer from it. Checking only the setting id
 * carries `bypass_region` into the order for an excluded offer.
 *
 * Returns a predicate, not a boolean, so a caller with a list of offers can test each one.
 * Memoised, so it is stable in an effect dependency list. A caller holding a single offer id
 * wants `isRegionFilterBypassedForOffer` below.
 */
export const selectRegionFilterBypassPredicate = createSelector(
  (state: App.State) => state.marketing.bypassRegionSettingId,
  (state: App.State) => state.marketing.bypassRegionExclusionOfferIds,
  (bypassRegionSettingId, bypassRegionExclusionOfferIds) => (offerId: string | undefined): boolean =>
    !!offerId && !!bypassRegionSettingId && !bypassRegionExclusionOfferIds.includes(offerId),
)

/** The same rule as `selectRegionFilterBypassPredicate`, for a caller that has one offer id. */
export function isRegionFilterBypassedForOffer(state: App.State, offerId: string | undefined): boolean {
  return selectRegionFilterBypassPredicate(state)(offerId)
}
